import './styles.scss';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import track from 'react-tracking';
import { Icon } from '@edx/paragon';
import { AddCircle, RemoveCircle } from '@edx/paragon/icons';
import { FormattedMessage, injectIntl } from 'gatsby-plugin-react-intl';

function BasePreviewExpand({
  heading,
  sectionTitle,
  children,
  cta,
  excludeIcon,
  className,
  innerClassName,
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={classNames('preview-expand-component', className)}>
      <div className="preview-expand-header d-flex position-relative">
        {heading}
        <a href={`#${cta.id}`} className="show-on-focus">
          <FormattedMessage
            id="prospectus.previewExpand.skip.label"
            description="Label for skipping over the section content."
            defaultMessage="Skip {sectionTitle}"
            values={{ sectionTitle }}
          />
        </a>
      </div>
      <div
        className={classNames(
          'preview-expand-body',
          innerClassName,
          { expanded: isExpanded },
        )}
      >
        {children}
      </div>
      <button
        onClick={toggleExpansion}
        className={classNames('preview-expand-cta', cta.className)}
        id={cta.id}
        type="button"
      >
        {!excludeIcon
          && (
            <Icon
              src={isExpanded ? RemoveCircle : AddCircle}
              className="mr-2 collapsible-icon"
            />
          )}
        {isExpanded ? cta.labelToMinimize : cta.labelToExpand}
      </button>
    </div>
  );
}

BasePreviewExpand.propTypes = {
  heading: PropTypes.node.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  cta: PropTypes.shape({
    id: PropTypes.string,
    labelToExpand: PropTypes.string,
    labelToMinimize: PropTypes.string,
    className: PropTypes.string,
  }).isRequired,
  excludeIcon: PropTypes.bool,
  className: PropTypes.string,
  innerClassName: PropTypes.string,
};

BasePreviewExpand.defaultProps = {
  excludeIcon: false,
  className: '',
  innerClassName: 'mb-4',
};

export default track({
  component: 'preview-expand',
})(injectIntl(BasePreviewExpand));
